<template>
  <div class="login">
    <div v-if="flag" @click="boxFlag = true">登录</div>
    <div v-else style="text-align: right">
      欢迎{{ name }} 当前在线人数：{{ num }}人
      <el-switch
        style="display: block; margin-top: 20px; color: white"
        v-model="value"
        active-color="#409EFF"
        inactive-color="#ff4949"
        active-text="主持人视角"
        inactive-text="自由行走"
        v-if="adminFlag"
      >
      </el-switch>

      <el-switch
        style="display: block; margin-top: 20px; color: white"
        v-model="value1"
        active-color="#409EFF"
        inactive-color="#ff4949"
        active-text="查看房间用户"
        inactive-text="关闭"
      >
      </el-switch>

      <el-switch
        style="display: block; margin-top: 20px; color: white"
        v-model="value2"
        active-color="#409EFF"
        inactive-color="#ff4949"
        active-text="开启摄像头"
        inactive-text="关闭摄像头"
      >
      </el-switch>
    </div>
    <div class="box" v-if="boxFlag">
      <div class="line">
        <p>名称：</p>
        <el-input v-model="name" placeholder="请输入名称"></el-input>
      </div>

      <div class="line">
        <p>角色：</p>
        <div class="roleBox">
          <div v-for="(item, index) in roleList" :key="index" @click="roleValue = index">
            <img :src="item" :class="['avatar', index == roleValue ? 'active' : '']" />
          </div>
        </div>
      </div>
      <div class="line1">
        <el-button type="primary" @click="loginIn">确认</el-button>
        <el-button
          @click="
            boxFlag = false;
            roleValue = 0;
          "
          >取消</el-button
        >
      </div>
    </div>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <div class="audioList" v-if="value1">
        <div class="list">
          <p>{{ name }}</p>
          <div class="img" @click="closeAudio" v-if="audioFlag">
            <div class="black">
              <div class="green" style="height: 30%"></div>
            </div>
          </div>
          <img
            src="../assets/img/voiceclose.png"
            class="img"
            @click="closeAudio"
            v-else
          />
        </div>

        <div class="list" v-for="(item, index) in list" :key="index">
          <p>{{ item.name }}</p>
          <div class="img">
            <div class="black">
              <div class="green" :style="'height:' + item.volume * 200 + '%'"></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- <audio id="stream" autoplay style="width: 0"></audio> -->
    <div id="local_stream" autoplay style="width: 0"></div>
    <div class="shadow" v-if="outflag">
      <h1>退出登录倒计时:{{ endnum }}s</h1>
    </div>
  </div>
</template>
<script>
import Bus from "../../common/js/bus";

export default {
  data() {
    return {
      flag: true,
      num: 1,
      name: "",
      roleList: [
        require("../assets/img/role1.jpg"),
        require("../assets/img/role2.jpg"),
        require("../assets/img/role3.png"),
        require("../assets/img/role4.png"),
        require("../assets/img/role5.jpg"),
        require("../assets/img/role6.jpg"),
      ],
      roleValue: 0,
      boxFlag: false,
      value: false,
      value1: false,
      value2: false,
      list: [],
      audioFlag: false,
      adminFlag: false,
      timmer: "",
      loginFlag: false,
      room_id: 1,
      endnum: 300,
      outflag: false,
    };
  },
  methods: {
    loginIn() {
      if (!this.name) {
        this.$message({
          type: "error",
          message: "请输入昵称",
        });
        return;
      }
      if (document.o2.login) document.o2.login(this.name, this.room_id, this.roleValue);
      if (this.name == "admin_") {
        this.adminFlag = true;
      }
      this.$message({
        type: "success",
        message: "登陆成功，你的昵称是: " + this.name,
      });
      this.conne();
      this.flag = false;
      this.boxFlag = false;
      this.roleValue = 0;
    },
    //登陆语音
    async conne() {
      var num = String(this.name);
      this.$client.login(num, this.room_id);

      this.timmer = setInterval(() => {
        this.endnum--;
        if (this.endnum < 61) {
          this.outflag = true;
        }
        console.log(this.endnum);
        if (this.endnum == 0) {
          this.loginOut();
        }
      }, 1000);
    },

    //关闭麦克风
    closeAudio() {
      this.audioFlag = !this.audioFlag;
      Bus.$emit("mute", this.audioFlag);
    },

    online() {
      // console.log("用户在操作");
      this.endnum = 300;
      this.loginFlag = true;
      this.outflag = false;
    },

    //退出登录
    loginOut() {
      console.log("退出登录");
      this.$client.loginOut();
      clearInterval(this.timmer);
      this.$confirm("长时间未操作,您已经退出登录", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          location.reload();
        });
      (this.flag = true), (this.name = "");
      (this.value1 = false), (this.value = false);
    },
  },
  watch: {
    value(val) {
      Bus.$emit("admin_mode", val);
    },
    value2(val) {
      Bus.$emit("vmute", val);
    },
  },
  created() {
    document.addEventListener("click", this.online, false);
    document.addEventListener("keydown", this.online, false);
    this.room_id = Number(this.$route.query.room_id);
    Bus.$on("num", (target) => {
      this.num += target;
    });

    Bus.$on("list", (target) => {
      this.list = target;
    });

    Bus.$on("share_view", (target) => {
      if (target == true) {
        setTimeout(() => {
          this.$confirm("您已经进入主持人视角", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        }, 100);
      } else {
        setTimeout(() => {
          this.$confirm("您已经退出主持人视角", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          });
        }, 100);
      }
    });
  },
  destroyed() {
    document.removeEventListener("click", this.online, false);
    document.removeEventListener("keydown", this.online, false);
  },
};
</script>

<style lang="scss" scoped>
.shadow {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
  z-index: 999;
}
.login {
  position: absolute;
  top: 20px;
  color: #fff;
  right: 40px;
  z-index: 99;
  font-family: Source Han Sans TC;
  cursor: pointer;

  ::v-deep.el-switch__label {
    color: white;
  }
  ::v-deep.el-switch__label.is-active {
    color: #409eff;
  }
}
.box {
  width: 470px;
  height: 280px;
  background: #ffffff;
  box-shadow: 1px 3px 17px 1px rgba(66, 84, 142, 0.31);
  border-radius: 8px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  .line1 {
    // float: right;
    // margin-right: 20px;
    // margin-top: 20px;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  .line {
    display: flex;
    align-items: center;
    margin: 10px 0;
    p {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #666;
      margin-left: 20px;
    }
    .el-input {
      width: 200px;
      margin: 15px;
    }
    .roleBox {
      display: flex;
      width: 250px;
      flex-wrap: wrap;
      .avatar {
        width: 50px;
        height: 50px;
        border: 2px solid #bebebe;
        border-radius: 50%;
        margin-left: 20px;
      }
      .active {
        border: 2px solid #409eff;
        transition: 0.5s;
      }
    }
  }
}
.audioList {
  width: 190px;
  height: 458px;
  background: rgba($color: #fff, $alpha: 0.5);
  box-shadow: 1px 3px 17px 1px rgba(66, 84, 142, 0.31);
  border-radius: 8px;
  position: absolute;
  right: 0px;
  top: 120px;

  .list:first-of-type {
    margin-top: 10px;
  }
  .list {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 40px;
    p {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #333333;
      width: 100px;
      text-align: left;
    }
    .img {
      width: 14px;
      height: 21px;
      background-image: url("../assets/img/voice.png");
      position: relative;
      .black {
        width: 8px;
        height: 14px;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        background-color: black;
        border-radius: 4px;
        overflow: hidden;
        top: 0;
        position: relative;
        .green {
          width: 100%;
          background: #00ff00;
          position: absolute;
          bottom: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .login {
    font-size: 12px;
    right: 20px;
    top: 17px;
  }
  .box {
    width: 100%;
  }
}
</style>
